<template>
  <div
    class="relative w-full flex h-[90px] border border-[#E2E5EC] bg-[#FFFFFF] rounded-[10px] shadow-[0_4px_14px_rgba(0,0,0,0.03)] cursor-pointer hover:bg-blue-50"
    @click="$emit('open-folder')"
  >
    <div
      class="move h-full flex items-center justify-center aspect-square border-r border-[#E2E5EC]"
      :class="{'cursor-move': readonly}"
    >
      <svg
        width="36"
        height="36"
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="ml-1 move"
      >
        <g clip-path="url(#clip0_15191_86366)">
          <path
            d="M28.7529 32.5862H0.97147C0.33216 32.5862 -0.132737 31.9792 0.0342286 31.3616L6.34416 14.0623C6.45837 13.639 6.84257 13.3448 7.2814 13.3448H35.0629C35.7022 13.3448 36.0001 13.9556 36.0001 14.5694L29.6902 31.8687C29.576 32.292 29.1917 32.5862 28.7529 32.5862Z"
            fill="#94B8FC"
          />
          <path
            d="M31.2008 7.75862H15.5172L12.4138 3.41379H1.07503C0.481655 3.41379 0 3.89482 0 4.48882V31.0096C0.0428276 31.0109 0.0856552 31.0134 0.127241 31.0159L6.34345 14.0623C6.45766 13.6384 6.84186 13.3448 7.28069 13.3448H32.2759V8.83365C32.2759 8.23965 31.7942 7.75862 31.2008 7.75862Z"
            fill="#4F83E3"
          />
        </g>
        <defs>
          <clipPath id="clip0_15191_86366">
            <rect
              width="36"
              height="36"
              fill="white"
            />
          </clipPath>
        </defs>
      </svg>
    </div>

    <div class="flex flex-col justify-center p-6 w-full">
      <p class="text-lg text-[#44474A] font-semibold mb-0">
        {{ folder.name }}
      </p>
      <span class="text-sm text-[#9FA9BA] mb-0">
        {{ folder.length }} Variables
      </span>
    </div>

    <div
      v-if="!readonly"
      class="absolute top-1/2 right-[10px] transform -translate-y-1/2 z-[100]"
      @click.stop
      @mousedown.stop
      @touchstart.stop.prevent
    >
      <b-dropdown
        variant="new-project-card-dropdown"
        right
        dropup
        toggle-class="text-decoration-none !bg-transparent"
        menu-class="project-menu py-0 z-[100]"
        no-caret
      >
        <template #button-content>
          <svg
            width="24"
            height="5"
            viewBox="0 0 24 5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="2.5"
              cy="2.5"
              r="2.5"
              fill="#4F83E3"
            />
            <circle
              cx="12.0714"
              cy="2.5"
              r="2.5"
              fill="#4F83E3"
            />
            <circle
              cx="21.3572"
              cy="2.5"
              r="2.5"
              fill="#4F83E3"
            />
          </svg>
        </template>

        <b-dropdown-item
          class="d-flex align-items-center"
          link-class="dashboard-menu-link !flex items-center text-[15px]"
          @click.stop="editFolder"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="w-4 h-4 mr-2"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.8049 1.52858C11.5446 1.26823 11.1224 1.26823 10.8621 1.52858L1.52876 10.8619C1.40373 10.9869 1.3335 11.1565 1.3335 11.3333V14C1.3335 14.3682 1.63197 14.6666 2.00016 14.6666H4.66683C4.84364 14.6666 5.01321 14.5964 5.13823 14.4714L14.4716 5.13805C14.7319 4.8777 14.7319 4.45559 14.4716 4.19524L11.8049 1.52858ZM12.0002 5.72384L10.2763 3.99998L11.3335 2.94279L13.0574 4.66665L12.0002 5.72384ZM9.3335 4.94279L11.0574 6.66665L5.3335 12.3905L3.60964 10.6666L9.3335 4.94279ZM2.66683 11.6095L4.39069 13.3333H2.66683V11.6095Z"
              fill="currentColor"
            />
            <path
              d="M8.66683 13.3333C8.29864 13.3333 8.00016 13.6318 8.00016 14C8.00016 14.3682 8.29864 14.6666 8.66683 14.6666H14.0002C14.3684 14.6666 14.6668 14.3682 14.6668 14C14.6668 13.6318 14.3684 13.3333 14.0002 13.3333H8.66683Z"
              fill="currentColor"
            />
          </svg>

          Edit
        </b-dropdown-item>

        <delete-confirm
          title="Are you sure?"
          description="Folder will be deleted permanently."
          @confirm="deleteFolder"
        >
          <template #activator="{on}">
            <b-dropdown-item
              class="d-flex align-items-center"
              link-class="dashboard-menu-link !flex items-center text-[15px]"
              v-on="on"
              @click.stop
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="w-4 h-4 mr-2"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7.5 0.75C7.08579 0.75 6.75 1.08579 6.75 1.5V3H3C2.58579 3 2.25 3.33579 2.25 3.75C2.25 4.16421 2.58579 4.5 3 4.5H15C15.4142 4.5 15.75 4.16421 15.75 3.75C15.75 3.33579 15.4142 3 15 3H11.25V1.5C11.25 1.08579 10.9142 0.75 10.5 0.75H7.5ZM9.75 3H8.25V2.25H9.75V3Z"
                  fill="currentColor"
                />
                <path
                  d="M7.5 8.25C7.91421 8.25 8.25 8.58579 8.25 9V13.5C8.25 13.9142 7.91421 14.25 7.5 14.25C7.08579 14.25 6.75 13.9142 6.75 13.5V9C6.75 8.58579 7.08579 8.25 7.5 8.25Z"
                  fill="currentColor"
                />
                <path
                  d="M11.25 9C11.25 8.58579 10.9142 8.25 10.5 8.25C10.0858 8.25 9.75 8.58579 9.75 9V13.5C9.75 13.9142 10.0858 14.25 10.5 14.25C10.9142 14.25 11.25 13.9142 11.25 13.5V9Z"
                  fill="currentColor"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M3.00001 5.25C2.78259 5.25 2.57587 5.34435 2.43341 5.5086C2.29096 5.67285 2.2268 5.89083 2.25754 6.10607L3.57356 15.3182C3.73191 16.4267 4.68123 17.25 5.80095 17.25H12.1991C13.3188 17.25 14.2681 16.4267 14.4264 15.3182L15.7425 6.10607C15.7732 5.89083 15.709 5.67285 15.5666 5.5086C15.4241 5.34435 15.2174 5.25 15 5.25H3.00001ZM5.05849 15.1061L3.86476 6.75H14.1352L12.9415 15.1061C12.8887 15.4756 12.5723 15.75 12.1991 15.75H5.80095C5.42771 15.75 5.11127 15.4756 5.05849 15.1061Z"
                  fill="currentColor"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7.5 0.75C7.08579 0.75 6.75 1.08579 6.75 1.5V3H3C2.58579 3 2.25 3.33579 2.25 3.75C2.25 4.16421 2.58579 4.5 3 4.5H15C15.4142 4.5 15.75 4.16421 15.75 3.75C15.75 3.33579 15.4142 3 15 3H11.25V1.5C11.25 1.08579 10.9142 0.75 10.5 0.75H7.5ZM9.75 3H8.25V2.25H9.75V3Z"
                  stroke="white"
                  stroke-width="0.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M7.5 8.25C7.91421 8.25 8.25 8.58579 8.25 9V13.5C8.25 13.9142 7.91421 14.25 7.5 14.25C7.08579 14.25 6.75 13.9142 6.75 13.5V9C6.75 8.58579 7.08579 8.25 7.5 8.25Z"
                  stroke="white"
                  stroke-width="0.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.25 9C11.25 8.58579 10.9142 8.25 10.5 8.25C10.0858 8.25 9.75 8.58579 9.75 9V13.5C9.75 13.9142 10.0858 14.25 10.5 14.25C10.9142 14.25 11.25 13.9142 11.25 13.5V9Z"
                  stroke="white"
                  stroke-width="0.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M3.00001 5.25C2.78259 5.25 2.57587 5.34435 2.43341 5.5086C2.29096 5.67285 2.2268 5.89083 2.25754 6.10607L3.57356 15.3182C3.73191 16.4267 4.68123 17.25 5.80095 17.25H12.1991C13.3188 17.25 14.2681 16.4267 14.4264 15.3182L15.7425 6.10607C15.7732 5.89083 15.709 5.67285 15.5666 5.5086C15.4241 5.34435 15.2174 5.25 15 5.25H3.00001ZM5.05849 15.1061L3.86476 6.75H14.1352L12.9415 15.1061C12.8887 15.4756 12.5723 15.75 12.1991 15.75H5.80095C5.42771 15.75 5.11127 15.4756 5.05849 15.1061Z"
                  stroke="white"
                  stroke-width="0.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              Delete
            </b-dropdown-item>
          </template>
        </delete-confirm>
      </b-dropdown>
    </div>
  </div>
</template>

<script>
import DeleteConfirm from '@/components/editor/modals/DeleteConfirm.vue'

export default {
  name: 'GlobalVariableFolder',
  components: {DeleteConfirm},
  props: {
    folder: {
      type: Object,
      required: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    editFolder () {
      this.$emit('edit', this.folder)
    },
    deleteFolder () {
      this.$emit('delete', this.folder)
    }
  }
}
</script>
